import ServiceCRUD from '../../../services/ServiceCRUDFLEXUC';

class Service extends ServiceCRUD {
  constructor() {
    super('/api/hangup-cause');
  }
}

export default new Service();
